var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3381_70499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.7865 0H81.5056C86.1573 0 90 4.62162 90 10.2162V79.7838C90 85.3784 86.1573 90 81.5056 90H8.49438C3.8427 90 0 85.3784 0 79.7838V10.2162C0 4.62162 3.8427 0 8.49438 0H19.2135H70.7865Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 35.6367C57.4183 35.6367 61 32.055 61 27.6367C61 23.2184 57.4183 19.6367 53 19.6367C48.5817 19.6367 45 23.2184 45 27.6367C45 32.055 48.5817 35.6367 53 35.6367Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 107L60.8073 86.9447L22.9948 47.376C20.1302 44.3948 14.974 44.1238 11.8229 47.105L-30 87.7577V95.6172C-30 101.851 -24.5573 107 -17.9687 107H80Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1336 66.1453L74.4722 51.2056C71.5765 47.2218 64.5583 46.6682 60.7549 50.1235L46.2378 63.2487L65.2609 82.5245L71.3221 83.0026C78.6593 83.5814 85.0934 79.3321 85.5448 73.6096L86.1336 66.1453Z",
    fill: "#F4F4F4"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 86,
    height: 86,
    rx: 43,
    stroke: "white",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3381_70499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/uploadImage.57d5103ced4bf3a3eee06318bfb688ff.svg";
export { ForwardRef as ReactComponent };